import Upload from 'rc-upload';

export default Upload;
